import { render, staticRenderFns } from "./CustoConsulta.vue?vue&type=template&id=2fdbd3c5&scoped=true&"
import script from "./CustoConsulta.vue?vue&type=script&lang=js&"
export * from "./CustoConsulta.vue?vue&type=script&lang=js&"
import style0 from "./CustoConsulta.vue?vue&type=style&index=0&id=2fdbd3c5&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdbd3c5",
  null
  
)

export default component.exports